import { createFeatureSelector } from '@ngrx/store';

import { MODULE_KEY } from '../../constants';
import { EntityManagementState } from '../reducers';

export const entityManagementModuleSelector =
  createFeatureSelector<EntityManagementState>(MODULE_KEY);
